import React from 'react';

const TestimonialCard = ({ testimonial, cardWidth = 402, isMobile = false }) => {
  const W = isMobile ? 260 : cardWidth;
  const H = isMobile ? 274 : 334;
  const userInfoY = isMobile ? 204 : 242;

  // Unique IDs per card to avoid SVG gradient conflicts
  const p0 = `ts_p0_${testimonial?.id ?? 'x'}`;
  const p1 = `ts_p1_${testimonial?.id ?? 'x'}`;

  const initials = testimonial?.name
    ? testimonial.name.trim().split(/\s+/).map(n => n[0]).join('').substring(0, 2).toUpperCase()
    : '?';

  // Scale the 402×165 SVG shape to the card width
  const svgW = W;
  const svgH = isMobile ? Math.round(165 * W / 402) : 165;

  return (
    <div
      style={{
        width: W,
        height: H,
        borderRadius: isMobile ? '16px' : '20px',
        backgroundColor: '#FFFFFF',
        position: 'relative',
        overflow: 'hidden',
        boxShadow: '0px 10px 26px 0px rgba(0,0,0,0.04)',
        flexShrink: 0,
      }}
    >
      {/* Review text — starts from the top of the card */}
      <div
        style={{
          position: 'absolute',
          top: 24,
          left: 32,
          right: 32,
          color: '#1E1E1E',
          fontSize: isMobile ? '13px' : '16px',
          fontFamily: "'Red Hat Display', sans-serif",
          fontWeight: 400,
          lineHeight: '24px',
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitLineClamp: isMobile ? 5 : 6,
          WebkitBoxOrient: 'vertical',
        }}
      >
        {testimonial?.description}
      </div>

      {/* Red shape at bottom (exact Figma SVG, scaled to card width) */}
      <svg
        width={svgW}
        height={svgH}
        viewBox="0 0 402 165"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        style={{ position: 'absolute', bottom: 0, left: 0, display: 'block' }}
        aria-hidden="true"
      >
        <defs>
          <linearGradient id={p0} x1="201" y1="0" x2="201" y2="164.612" gradientUnits="userSpaceOnUse">
            <stop stopColor="#EC1B26" />
            <stop offset="1" stopColor="#FF4A60" />
          </linearGradient>
          <linearGradient id={p1} x1="201" y1="0" x2="201" y2="164.612" gradientUnits="userSpaceOnUse">
            <stop stopColor="#EC1B26" />
            <stop offset="1" stopColor="#FF4A60" />
          </linearGradient>
        </defs>
        <path
          d="M0 75.5102C0 54.6586 22.3858 37.7551 50 37.7551H402V149.51C402 157.851 393.046 164.612 382 164.612H20C8.9543 164.612 0 157.851 0 149.51V75.5102Z"
          fill={`url(#${p0})`}
        />
        <path
          d="M352.02 37.7551H402V3.30066e-06C402 4.95807 400.707 9.86759 398.194 14.4483C395.681 19.0289 391.998 23.191 387.355 26.6969C382.712 30.2028 377.2 32.9838 371.134 34.8812C365.074 36.7767 358.579 37.7532 352.02 37.7551Z"
          fill={`url(#${p1})`}
        />
      </svg>

      {/* User info over red area */}
      <div
        style={{
          position: 'absolute',
          top: userInfoY,
          left: 41,
          display: 'flex',
          alignItems: 'center',
          gap: 16,
          zIndex: 1,
        }}
      >
        {/* Avatar circle with initials */}
        <div
          style={{
            width: 48,
            height: 48,
            borderRadius: '50%',
            backgroundColor: '#FFFFFF',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <span
            style={{
              fontFamily: "'Red Hat Display', sans-serif",
              fontWeight: 600,
              fontSize: '16px',
              background: 'linear-gradient(180deg, #EC1B26 0%, #FF4A60 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            {initials}
          </span>
        </div>

        {/* Name */}
        <div
          style={{
            fontFamily: "'Red Hat Display', sans-serif",
            fontWeight: 700,
            fontSize: isMobile ? '15px' : '18px',
            color: '#FFFFFF',
            lineHeight: '24px',
          }}
        >
          {testimonial?.name}
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
